export const InsuranceContainer = () => {
  return 'Раздел "Страхование" находится в разработке...';
};
